import { setActivePinia } from 'pinia';
import { defineCustomElement, h, provide } from 'vue';
import { I18nInjectionKey } from 'vue-i18n';

import BookingWidgetCE from '@/lib/BookingWidgetCE.ce.vue';
import CarouselCE from '@/lib/CarouselCE.ce.vue';
import CarouselListCE from '@/lib/CarouselListCE.ce.vue';
import CartCE from '@/lib/CartCE.ce.vue';
import CartDetailsCE from '@/lib/CartDetailsCE.ce.vue';
import CartWidgetCE from '@/lib/CartWidgetCE.ce.vue';
import CartYoubookWidgetCE from '@/lib/CartYoubookWidgetCE.ce.vue';
import PassTourismCE from '@/lib/PassTourismCE.ce.vue';
import ProductDetailsCE from '@/lib/ProductDetailsCE.ce.vue';
import ProductsListCe from '@/lib/ProductsListCE.ce.vue';
import ProductsListSearchCe from '@/lib/ProductsListSearchCE.ce.vue';
import ProductsListSliderCe from '@/lib/ProductsListSliderCE.ce.vue';
import RoadbookListCE from '@/lib/RoadbookListCE.ce.vue';
import WidgetEditorCE from '@/lib/WidgetEditorCE.ce.vue';
import WidgetEditorSearchEngineCE from '@/lib/WidgetEditorSearchEngineCE.ce.vue';
import YoubookConfigurationCe from '@/lib/YoubookConfigurationCE.ce.vue';
import { i18n, pinia, sharedSheet } from '@/shared-instance';

const registry = {
  'yb-configuration': YoubookConfigurationCe,
  'yb-search': ProductsListSearchCe,
  'yb-slider': ProductsListSliderCe,
  'yb-list': ProductsListCe,
  'yb-details': ProductDetailsCE,
  'yb-carousel': CarouselCE,
  'yb-carousel-list': CarouselListCE,
  'yb-pass-form': PassTourismCE,
  'yb-cart': CartCE,
  'yb-cart-widget': CartWidgetCE,
  'yb-rdbk-list': RoadbookListCE,
  'yb-widget-editor': WidgetEditorCE,
  'yb-widget-editor-search-engine': WidgetEditorSearchEngineCE,
  'yb-booking-widget': BookingWidgetCE,
  'yb-cart-details': CartDetailsCE,
  'yb-cart-youbook-widget': CartYoubookWidgetCE,
};

// Host sites sometimes inject their own markup inside these tags: it is never
// rendered (no <slot> in the Shadow DOM) but pollutes the light DOM, so we wipe it.
const clearLightDomTags = new Set(['yb-details']);

Object.entries(registry).forEach(([tagName, component]) => {
  const customElement = defineCustomElement({
    props: component.props, // Crucial: copy prop definitions
    setup(props) {
      setActivePinia(pinia);
      provide(I18nInjectionKey, i18n.global);
      return () => h(component, props); // Pass props to the child
    },
  });

  customElements.define(tagName, class extends customElement {
    connectedCallback() {
      super.connectedCallback();
      if (this.shadowRoot) {
        // Pierces the shadow DOM with shared styles instantly (No CLS)
        this.shadowRoot.adoptedStyleSheets = [sharedSheet];
      }
      if (clearLightDomTags.has(tagName)) {
        // Removes markup present before upgrade
        this.replaceChildren();
      }
    }
  });
});
